import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you for your message! We\'ll get back to you soon.');
      setFormData({
        name: '',
        email: '',
        company: '',
        service: '',
        message: ''
      });
    }, 2000);
  };

  const contactInfo = [
    {
      icon: '📍',
      title: 'Address',
      details: '123 Innovation Street<br />Tech City, TC 12345<br />United States'
    },
    {
      icon: '📧',
      title: 'Email',
      details: 'rohit@codersbrain.com'
    },
    {
      icon: '📞',
      title: 'Phone',
      details: '+1 (555) 123-4567<br />+1 (555) 987-6543'
    },
    {
      icon: '🕒',
      title: 'Business Hours',
      details: 'Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 2:00 PM'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
	return (
		<div className="min-h-screen bg-white">
			{/* Top Banner */}
			<div className="py-4" style={{ backgroundColor: '#42FF00' }}>
				<div className="max-w-7xl mx-auto px-6 pt-12">
					<h1 className="text-2xl font-bold text-black text-left">Analytical Prism</h1>
				</div>
			</div>

			{/* Main Content */}
			<div className="max-w-4xl mx-auto px-6 py-12">
				{/* Header Section */}
				<div className="grid md:grid-cols-2 gap-8 mb-12">
					<div>
						<motion.h2 
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.6 }}
							className="text-6xl md:text-7xl font-light italic mb-6"
						>
							<div>Let's</div>
							<div className="">
								<span className="border-b-2 border-blue-500 pb-1">Connect</span>
							</div>
						</motion.h2>
					</div>
					<div className="flex items-center">
						<p className="text-gray-700 leading-relaxed">
							At Analytical Prism, we are committed to helping institutions, businesses, and individuals make informed, science-driven decisions. Whether you're interested in our solutions, research collaborations, or business partnerships, we'd love to hear from you.
						</p>
					</div>
				</div>

				{/* Form Instructions */}
				<motion.p 
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.6, delay: 0.2 }}
					className="text-gray-600 mb-8 text-start"
				>
					For inquiries, please fill out the form below, and our team will get back to you shortly.
				</motion.p>

				{/* Contact Form */}
				<motion.form 
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6, delay: 0.4 }}
					onSubmit={handleSubmit}
					className="space-y-6"
				>
					<div>
						<input
							type="text"
							name="fullName"
							value={formData.fullName}
							onChange={handleInputChange}
							required
							className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
							style={{ borderColor: '#113861' }}
							placeholder="Full Name *"
						/>
					</div>
					<div>
						<input
							type="email"
							name="email"
							value={formData.email}
							onChange={handleInputChange}
							required
							className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
							style={{ borderColor: '#113861' }}
							placeholder="Email ID*"
						/>
					</div>

					<div>
						<input
							type="tel"
							name="mobile"
							value={formData.mobile}
							onChange={handleInputChange}
							required
							className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
							style={{ borderColor: '#113861' }}
							placeholder="Mobile Number*"
						/>
					</div>

					<div>
						<div className="flex space-x-8">
							{[
								{ value: 'general', label: 'General Inquiry' },
								{ value: 'business', label: 'Business Collaboration' },
								{ value: 'research', label: 'Research Partnership' }
							].map((option) => (
								<label key={option.value} className="flex items-center">
									<input
										type="radio"
										name="inquiryType"
										value={option.value}
										checked={formData.inquiryType === option.value}
										onChange={handleInputChange}
										className="w-4 h-4 border-gray-300 focus:ring-2"
										style={{ 
											accentColor: '#42FF00',
											borderColor: '#113861'
										}}
									/>
									<span className="ml-3 text-gray-700">{option.label}</span>
								</label>
							))}
						</div>
					</div>

					<div>
						<textarea
							name="details"
							value={formData.details}
							onChange={handleInputChange}
							rows={5}
							className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
							style={{ borderColor: '#113861' }}
							placeholder="Provide details about your inquiry"
						/>
					</div>

					<div className="text-center">
						<button
							type="submit"
							className="text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 flex items-center justify-center mx-auto space-x-2"
							style={{ backgroundColor: '#42FF00' }}
						>
							<span>Submit</span>
							<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
							</svg>
						</button>
					</div>
				</motion.form>
			</div>
		</div>
	);
};

export default Contact;
